module.exports = __webpack_public_path__ + "img/therapeuticPhysiotherapy.9b6b1e73.svg";